module.exports = __webpack_public_path__ + "static/media/ugpgBanner1.a36af2bf.png";